
<template>
    <div class="center reglas">
        <vs-table>
            <template #thead>
                <vs-tr>
                    <vs-th class="text-center centrarHeader" width="200px">
                        <span>Concepto</span>
                    </vs-th>
                    <vs-th class="text-center centrarHeader">
                        <span>Fecha de vigencia</span>
                    </vs-th>
                    <vs-th class="text-center centrarHeader">
                        <span>Tipo de Alumno</span>
                    </vs-th>
                    <vs-th class="text-center centrarHeader">
                        <span>Tipo de Cobro</span>
                    </vs-th>
                    <vs-th class="text-center centrarHeader">
                        <span>Monto</span>
                    </vs-th>
                    <vs-th class="text-center centrarHeader" width="50px">
                        <span>Acciones</span>
                    </vs-th>
                </vs-tr>
            </template>
            <template #tbody>
                <vs-tr
                    :key="i"
                    v-for="(item, i) in $vs.getSearch(filterRegs, search)"
                    :data="item"
                >
                    <vs-td>
                        <vs-row>
                            <vs-col sm="4" lg="4" class="figma-table">
                                <div
                                    class="bpill rounded-circle d-inline-flex justify-content-center align-items-center mr-2 bpill--servicio"
                                    :class="{
                                        'bpill--inscripcion': item.codigos_detalles.categoria.includes('inscripcion'),
                                        'bpill--colegiatura': item.codigos_detalles.categoria.includes('colegiatura'),
                                    }">
                                    <span v-if="item.codigos_detalles.categoria.includes('inscripcion')">I</span>
                                    <span v-else-if="item.codigos_detalles.categoria.includes('colegiatura')">C</span>
                                    <span v-else>S</span>
                                </div>
                            </vs-col>
                            <vs-col sm="8" lg="8">
                                 <span class="text-uppercase ml-2 fs-14 text-dark">{{item.codigos_detalles.nombre}}</span>
                                <div v-if="item.subcategoria_servicio_id">
                                    <p class="mb-0"><small>SUBCATEGORÍA</small></p>
                                    <div v-for="sub in subcategorias" :key="sub.subcategoria_id">
                                        <p v-if="sub.subcategoria_id == item.subcategoria_servicio_id"><strong>{{sub.nombre}}</strong></p>
                                    </div>
                                </div>
                                
                            </vs-col>
                        </vs-row>
                    </vs-td>
                    <vs-td>
                        <div class="text-center">
                            <span><i class="far fa-calendar"></i> <strong>{{ item.f_vigencia }}</strong></span><br>
                            <span class="text-muted">{{ item.nombre_f_vigencia }}</span>
                        </div>
                    </vs-td>
                    <vs-td class="text-center">
                        <md-chip :class="'mini-chip col-' + statusColores[item.tipo_alumno]['color']" ><strong> {{item.tipo_alumno}}</strong></md-chip>
                        <div v-for="(programa, p) in programas" :key="p">
                            <p v-if="item.programa_id == programa.id">
                                <span>{{programa.text}}</span>
                            </p>
                        </div>
                        <div v-for="nivel in niveles" :key="nivel.id">
                            <p v-if="item.nivel_academico_id == nivel.id">
                                <span>{{nivel.text}}</span>
                            </p>
                        </div>
                    </vs-td>
                    <vs-td class="text-center">
                        <strong>{{ item.tipo_cobro }}</strong>
                    </vs-td>
                    <vs-td class="text-center">
                        <strong>{{ item.monto | currency }}</strong><br>
                        <span>{{ (item.leyenda_creditos) ? item.leyenda_creditos : '' }}</span>
                    </vs-td>
                    <vs-td class="text-center">
                        <md-menu md-size="small" md-align-trigger :md-offset-x="-120">
                            <vs-button
                                success
                                flat
                                md-menu-trigger
                            >
                                <i class="fas fa-ellipsis-v"></i>
                            </vs-button>

                            <md-menu-content>
                                <md-menu-item @click="activeEditar =! activeEditar; selectedRow = item">Editar</md-menu-item>
                                <md-menu-item @click="activeEliminar =! activeEliminar; selectedRow = item">Eliminar</md-menu-item>
                            </md-menu-content>
                        </md-menu>
                    </vs-td>
                </vs-tr>
            </template>
            <template #notFound>
                Sin información
            </template>
        </vs-table>
        <editar v-model="activeEditar" :selectedRow="selectedRow" :institucion="institucion" :ciclosEscolares="ciclosEscolares" :cicloEscolar="cicloEscolar" :instituciones="instituciones" @refreshTable="getRefresh"></editar>
        <eliminar v-model="activeEliminar" :selectedRow="selectedRow" @refreshTable="getRefreshEliminar"></eliminar>
    </div>
</template>
<script>
import administracion from '../../../../api/requests/administracion'
import Editar from './modales/editar.vue'
import Eliminar from './modales/eliminar.vue'
import academico from '../../../../api/requests/academico'
export default {
    props: [
        'regs',
        'filter',
        'institucion',
        'instituciones',
        'ciclosEscolares',
        'cicloEscolar',
    ],
    data:() => ({
        search: '',
        activeEditar: false,
        activeEliminar: false,
        selectInfo: [],
        categoriasColores: {
            "inscripcion" : {
                "color" : "#33cf4c",
                "abv" : "I"
            },
            "servicio" : {
                "color" : "#800080",
                "abv" : "S"
            },
            "colegiatura" : {
                "color" : "#009efb",
                "abv" : "C"
            },
        },
        statusColores:{
            "Nuevo ingreso": {
                "color": "orange"
            },
            "Reingreso": {
                "color": "blue"
            }
        },
        programas: [],
        niveles: [],
        selectedRow: [],
        subcategorias: []
    }),
    components: {
        Editar,
        Eliminar
    },
    methods:{
        getRefresh(institucion, cicloEscolar){
            this.$emit('refreshTable', institucion, cicloEscolar)
        },
        getRefreshEliminar(){
            this.$emit('refreshTableEliminar')
        },
        getColor(metodo){
            if(metodo == 'servicio'){
                return 'bpill--servicio'
            }
            if(metodo == 'porcentaje'){
                return 'bpill--porcentaje'
            }
            if(metodo == 'monto'){
                return 'bpill--monto'
            }

        },
        async getPrograma(){
            if (this.institucion) {
                try {
                    const {data: response} = await administracion.getProgramas(this.institucion)
                    this.programas = response
                } catch (error) {
                    
                }
            }
        },
        async getNivelAcademico() {
            if(this.institucion){
                const params = {
                    "institucion_id": this.institucion
                }
                const { data: response } = await administracion.getNivelAcademico(params)
                this.niveles = response
            }
        },
        
        async getSubcategoria(){
            if(this.cicloEscolar){
                this.loadingSubcategoria = true
                const params = {
                    ciclo_escolar_id: this.cicloEscolar,
                    institucion_id: this.institucion
                }
                if(this.codigoDetalle != ''){
                    params.codigo_detalle_id = this.codigoDetalle
                }
                const { data: response } = await academico.getSubcategoriasServicios(params)
                this.subcategorias = response
            }
        },
    },
    computed: {
        filterRegs() {
            if (this.filter) {
                return this.regs.filter(reg => {
                    const filterBy = [
                        reg.codigos_detalles.nombre,
                        reg.codigos_detalles.categoria,
                        reg.f_vigencia,
                        reg.tipo_alumno,
                        reg.tipo_cobro,
                        reg.monto,
                    ];

                    const sfilterBy = filterBy.map(x => x.toString().toLowerCase());

                    return sfilterBy.some(camp => camp.includes(this.filter.toLowerCase()));
                });
            }

            return this.regs;
        }
    },
    watch:{
        regs(){
            this.getPrograma()
            this.getNivelAcademico()
        },
        cicloEscolar(){
            this.getSubcategoria()
        }
    }
}
</script>
<style lang="scss" scoped>
.fs-14 {
    font-size: 14px;
}
.figma-table {
    .bpill {
        color: white;
        width: 40px;
        height: 40px;
        flex-shrink: 0;
    }


    .bpill--servicio {
        background-color: purple;
    }

    .bpill--inscripcion {
        background-color: #33cf4c;
    }

    .bpill--colegiatura {
        background-color: #009efb;
    }

    thead th {
        padding: 20px;
    }

    thead th:first-child {
        border-top-left-radius: 20px;
        width: 180px;
    }

    thead th:nth-child(2) {
        width: 320px;
    }

    thead th:last-child {
        border-top-right-radius: 20px;
    }

    .apill {
        min-width: 150px;
    }

    .apill--reingreso {
        background-color: #baece6;
        color: #16beaa;
    }

    .apill--ingreso {
        background-color: #ffeed4;
        color: #ffa928;
    }

    .fbutton {
        border: none;
        width: 35px;
        height: 35px;
    }

    .fbutton--edit {
        background-color: #e3f7e2;
        color: #65cd65;
    }

    .fbutton--delete {
        background-color: #ffe4e6;
        color: #ff4757;
    }
}
    .col-blue {
        background-color: #baece6;
        color: #16beaa;
    }

    .col-orange {
        background-color: #ffeed4;
        color: #ffa928;
    }

</style>

<style>
.reglas .vs-table-content .vs-table table{
    margin: 2% 0 !important;
    width: 100% !important;
}
.centrarHeader .vs-table__th__content{
    justify-content: center;
}

</style>


        